/** @format */

import { reducerDebug } from '../../core/debug';
import { vatConstants } from './vatActions';
import { VatCollectionInterface } from '../../interfaces/collections/VatCollectionInterface';

const initialState = {
    vats: undefined as VatCollectionInterface | undefined,
};

export type VatReducersType = {
    type?: string;
    vats: VatCollectionInterface | undefined;
};

export function vatReducers(state = initialState, action: VatReducersType): object {
    reducerDebug('Vat reducer: ' + action.type, state, action);
    switch (action.type) {
        case vatConstants.VAT_LIST:
            return {
                ...state,
                vats: action.vats,
            };
        default:
            return {
                ...state,
            };
    }
}
